module.exports = __webpack_public_path__ + "img/spray-bottle.d7b66b79.png";